export default __webpack_public_path__ + "static/media/puff.36d4d315.svg";